import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'components/button';
import styles from './index.module.scss';
import OnBoardingLayout from 'layout/onboarding';
import { useMochiPayFlowContext, SHOW_LOADING } from '../use-mochi-pay-flow';
import { useInterval } from 'helpers/time-helper';
import iconMochipay from 'assets/icon_mochipay.svg';
import logo from 'assets/logo_cpc.png';
import hint from 'assets/icon_hint.svg';
import amplitude from 'service/amplitude';

const Loading = () => {
  const { state } = useMochiPayFlowContext();
  const [animationCount, setAnimationCount] = useState(0);
  const dots = ['.', '..', '...', '..'];

  useInterval(() => {
    setAnimationCount(prev => prev + 1);
  }, 300);

  if (state.loading) {
    return (
      <div className={styles.loading}>
        <img height={25} src={iconMochipay} alt="logo" />
        <div className={styles.text}>
          {`授權處理中${dots[animationCount % 4]}`}
          <br />
          請勿關閉 APP 或離開畫面
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

const MochiPayConfirm = () => {
  const history = useHistory();
  const { state, dispatch, createWallet } = useMochiPayFlowContext();

  const bindCpcPayCard = () => {
    amplitude.payment_bindCard_confirm_onClick(); //deprecate
    amplitude.payment_linkCard_onClick();
    dispatch({ type: SHOW_LOADING });
    createWallet();
  };

  const onPass = () => {
    amplitude.payment_bindCard_cancel_onClick();
    history.goBack();
  };

  return (
    <OnBoardingLayout className={styles['mochi-pay-confirm']}>
      <Loading show={state.loading} />
      <div className={styles.top}>
        <div className={styles.card}>
          <img src={logo} alt="cpc-logo" />
        </div>
        <div className={styles.title}>
          連結中油 Pay
          <br />
          信用卡/簽帳金融卡
        </div>
        <div className={styles.desc}>立即開始享受路邊停車自動繳的便利，停車場也能馬上體驗麻吉付！</div>
        <div className={`${styles.hint} ${styles['with-icon']}`}>
          <img src={hint} alt="hint" />
          連結過程將產生一筆台幣 1 元的過卡交易，不會實際請款。
        </div>
      </div>
      <div className={styles.bottom}>
        <Button theme="blue" block={true} loading={state.buttonLoading} onClick={bindCpcPayCard}>
          確認連結
        </Button>
        <Button theme="link" block={true} onClick={onPass}>
          返回
        </Button>
      </div>
    </OnBoardingLayout>
  );
};

export default MochiPayConfirm;
